// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"406a4a5c","703":"a3263380"}[chunkId] + ".chunk.js";
};